import { useQuery } from '@tanstack/react-query';
import { Moon } from 'lucide-react';
import { api } from '@/lib/api';

interface AjustesPublicos {
  platformOpen: boolean;
  platformClosedMessage: string;
}

/**
 * El telón de la plataforma apagada.
 *
 * Cuando el administrador apaga el servicio —un festivo, fuera de horario—,
 * esto cubre la tienda entera con el aviso. No tiene botón de cerrar a
 * propósito: la tienda está cerrada, no «cerrada salvo que insistas». El
 * servidor rechaza igual cualquier pedido (`PLATFORM_CLOSED`), así que esto
 * es cortesía, no seguridad.
 *
 * Se consulta cada minuto: encender vuelve a abrir la tienda solo, sin que
 * el cliente tenga que recargar. Si la consulta falla (red caída), se asume
 * abierta: bloquear por un error de red castigaría al cliente equivocado.
 */
export function AvisoCerrado() {
  const estado = useQuery({
    queryKey: ['plataforma-estado'],
    queryFn: async () => (await api.get<AjustesPublicos>('/public/ajustes')).data,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });

  if (estado.data?.platformOpen !== false) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Servicio no disponible"
      className="fixed inset-0 z-[100] grid place-items-center bg-kick-dark/80 p-4 backdrop-blur-sm"
    >
      <div className="w-full max-w-md rounded-kick bg-white p-8 text-center shadow-2xl">
        <img src="/logo.png" alt="Kick Domicilios" className="mx-auto h-16 w-auto" />
        <span className="mx-auto mt-5 grid h-12 w-12 place-items-center rounded-full bg-kick-light">
          <Moon className="h-6 w-6 text-kick-gray" />
        </span>
        <h2 className="mt-4 text-2xl font-bold text-kick-dark">Estamos cerrados</h2>
        <p className="mt-2 text-kick-gray">{estado.data.platformClosedMessage}</p>
      </div>
    </div>
  );
}
